import {
  ChartPieIcon as CommunityLockedLiquidityIcon,
  DocumentTextIcon as DocumentationIcon,
  InformationCircleIcon as InfoIcon,
  MapIcon as RoadMapIcon,
} from '@heroicons/react/outline';
import { ResourceCard } from 'components/Card';
import React from 'react';
import { useTranslation } from 'react-i18next';

const Resources = () => {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-4">
      <ResourceCard
        title={t('resources.title_introduction')}
        icon={InfoIcon}
        body={t('resources.description_introduction')}
        url="https://docs.surf.finance/"
      />
      <ResourceCard
        title={t('resources.title_not_a_roadmap')}
        icon={RoadMapIcon}
        body={t('resources.description_not_a_roadmap')}
        url="https://docs.surf.finance/not-a-roadmap"
      />
      <ResourceCard
        title={t('resources.title_smart_contracts')}
        icon={DocumentationIcon}
        body={t('resources.description_smart_contracts')}
        url="https://docs.surf.finance/smart-contracts"
      />
      <ResourceCard
        title={t('resources.title_community_locked_liquidity')}
        icon={CommunityLockedLiquidityIcon}
        body={t('resources.description_community_locked_liquidity')}
        url="https://docs.surf.finance/community-locked-liquidity"
      />
    </div>
  );
};
export default Resources;
